import { render, staticRenderFns } from "./menuCatalogList.vue?vue&type=template&id=6e1092d6&scoped=true"
import script from "./menuCatalogList.vue?vue&type=script&lang=js"
export * from "./menuCatalogList.vue?vue&type=script&lang=js"
import style0 from "./menuCatalogList.vue?vue&type=style&index=0&id=6e1092d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1092d6",
  null
  
)

export default component.exports